import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import CoreCalendar from "../../../app/core/components/CoreCalendar/CoreCalendar";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import StudioFilter from "../../../app/core/components/UserFilter/StudioFilter";
import { ROLE } from "../../../utils/constants/profiles";
import { TABLE_ROWS_NUMBER } from "../../../utils/constants/tables";
import { useGetStudiosQuery } from "../../api/admin/gestisciStudioApi";
import { useGetNotificheQuery } from "../../api/admin/notificheApi";
import CreateNotifica from "./CreateNotifica";

const NotifichePage = () => {
  const { t } = useTranslation();
  const role = useSelector((state) => state.app.role);
  const studioID = useSelector((state) => state.app.studioId);
  const colorPrimary = useSelector((state) => state.app.primaryColor);

  const [notifica, setNotifica] = useState(null);
  const [createNotifica, setCreateNotifica] = useState();
  const [openNotificaCreateModal, setOpenNotificaCreateModal] = useState(false);
  const [studio, setStudio] = useState();
  const [debouncedInputStudioValue, setDebouncedInputStudioValue] =
    useState("");

  const page = {
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  };

  const validIdStudio = role !== ROLE.ADMIN ? studioID : studio?.id;

  const { data, isLoading } = useGetNotificheQuery(
    { studioId: validIdStudio },
    { skip: !validIdStudio }
  );
  const { data: studios } = useGetStudiosQuery(
    { ...page, value: debouncedInputStudioValue },
    {
      skip: role !== ROLE.ADMIN,
    }
  );

  const handleOpenEditModal = (notifica) => {
    setNotifica(notifica);
    setOpenNotificaCreateModal(true);
  };
  const handleOpenCreateModal = (el) => {
    setCreateNotifica(el);
    setOpenNotificaCreateModal(true);
  };

  const handleCloseNotificaCreateModal = () => {
    setOpenNotificaCreateModal(false);
    setNotifica(null);
  };

  return (
    <div className="h-full">
      <h2>
        {studio ? (
          <>
            {t("ManageDeadline")}
            <span style={{ color: colorPrimary }}>
              {" Sede: " + studio.label}
            </span>
          </>
        ) : (
          t("ManageDeadline")
        )}
      </h2>

      <div className="flex space-x-8 flex-col lg:flex-row space-y-8 lg:space-y-0">
        <div className="w-full lg:w-8/12">
          {!isLoading ? (
            <CoreCalendar
              onCreate={handleOpenCreateModal}
              events={
                studio || role !== ROLE.ADMIN
                  ? data?.Data?.map((el) => ({
                      id: el.id,
                      title: el.title,
                      date: el.notifyAt,
                      extendedProps: {
                        description: el.description,
                      },
                    }))
                  : ""
              }
              onOpen={handleOpenEditModal}
            />
          ) : (
            <div
              className="flex justify-center items-center "
              style={{
                height: "70vh",
              }}
            >
              <CoreSpinner />
            </div>
          )}
        </div>
        {!isLoading && (
          <div className="w-full lg:w-4/12 flex flex-col items-center justify-start shadow-md">
            {role === ROLE.ADMIN && !isLoading && (
              <div className="py-5">
                <h3>{`${t("SelectStudioForDeadline")}`}</h3>

                <div className="w-full">
                  <StudioFilter
                    selectedUser={studio}
                    setSelectedUser={setStudio}
                    usersList={studios?.Data?.items}
                    setDebouncedInputUserValue={setDebouncedInputStudioValue}
                    startAdornment={
                      <>
                        <SearchRoundedIcon size={20} />
                      </>
                    }
                  />
                </div>
              </div>
            )}

            {openNotificaCreateModal ? (
              <CreateNotifica
                notifica={notifica}
                handleClose={handleCloseNotificaCreateModal}
                create={createNotifica}
                studioId={validIdStudio}
              />
            ) : (
              <div
                className="w-full h-full flex items-center justify-center"
                style={{ minHeight: "30vh" }}
              >
                <p className=" text-gray">nessuna scadenza selezionata</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default NotifichePage;
